import { init } from './_fontawesome';

/** Fontawesome plugin. */
const fontawesomePlugin = {
  init,
};

export default fontawesomePlugin;
